import AgdCard from '../agdCard'
import styles from './index.module.less'
import { useEffect, useState } from 'react'
import { useRequest } from 'ahooks'
import { getAgdPledgeList } from '@/api/account'
import type { IResAgdPledgeListItem } from '@/api/account/interface'
import MeEmpty from '@/components/MeEmpty'
import LoadingCom from '@/components/LoadingCom'
interface IProps {
  address: string
  activeValue: string | undefined
  pageParams: {
    page: number
    limit: number
  }
  setAgdTotal: (total: number) => void
  setAgdLoading: (loading: boolean) => void
}
const AgdList = ({ address, activeValue, pageParams, setAgdTotal, setAgdLoading }: IProps) => {
  const listParams = {
    address,
    page_number: pageParams.page,
    page_size: pageParams.limit,
  }
  const [agdList, setAgdList] = useState<IResAgdPledgeListItem[]>([])
  const { loading, run } = useRequest(() => getAgdPledgeList(listParams), {
    manual: true,
    onSuccess: (res) => {
      // "AGR"
      setAgdList(res?.agdDelegation?.filter((item) => item.delegationType !== 'AGR') || [])
      setAgdTotal(res?.total || 0)
    },
  })

  useEffect(() => {
    run()
  }, [pageParams, run, address])

  useEffect(() => {
    setAgdLoading(loading)
  }, [loading, setAgdLoading])

  return (
    <>
      {activeValue === '1' && (
        <div className={styles.wrap}>
          {loading && <LoadingCom />}
          {!loading && agdList.length === 0 && <MeEmpty />}
          {agdList.map((item, index) => (
            <AgdCard {...item} key={`${index}`} />
          ))}
        </div>
      )}
    </>
  )
}

export default AgdList
